module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VYi2xm/tc-custom/9781459262812.jpg?1726519129393",
      "alt": "This image is the cover for the book Bargaining with the Boss, Pennington"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bargaining with the Boss, Pennington\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("PENNINGTON")]), _c('br'), _c('br'), _c('b', [_vm._v("Moment of truth!")]), _c('br'), _c('br'), _vm._v("Eleri worked hard at being levelheaded, to make up for one solitary mistake in her teens. But there were times when being sensible was difficult! Take the situation with James Kincaid."), _c('br'), _c('br'), _vm._v("Eleri had been in love with James, her former boss, for ages, and now not only was James begging her to return to the job from which she'd resigned, he made it clear he found her very attractive, too!"), _c('br'), _c('br'), _vm._v("Eleri longed to give in to her feelings for James, but forced herself to keep her distance. She had to, because of her secret: what if James discovered that Nico, the boy he thought of as her younger brother, was actually her son?"), _c('br'), _c('br'), _c('b', [_vm._v("PENNINGTON"), _c('br'), _c('i', [_vm._v("A place where dreams come true")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Catherine George\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Catherine George was born in Wales, and early on developed a passion for reading which eventually fuelled her compulsion to write.  Marriage to an engineer led to nine years in Brazil, but on his later travels the education of her son and daughter kept her in the UK.  And, instead of constant reading to pass her lonely evenings, she began to write the first of her romantic novels.  When not writing and reading she loves to cook, listen to opera, and browse in antiques shops.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0